module.exports = {"svg":{"$":{"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 16 16"},"title":["UI_Filter_16"],"polygon":[{"$":{"points":"15 2 1 2 6 8 6 14 10 11 10 8 15 2","fill":"#464646"}}]}}


//////////////////
// WEBPACK FOOTER
// ./node_modules/xml-loader!./src/svg/UI_Filter_16.svg
// module id = 420e
// module chunks = 1